const logDescriptionTable = log => {
    switch (log) {
        case 'auth':
            return {
                name:        'Authorization',
                description: 'Authentication audit for the BAS Agent.'
            };
        case 'combined-logs':
            return {
                name:        'All Logs',
                description: 'Combined log composed of all other logs.'
            };
        case 'next-bas-agent-bacnet-broker-handler-dev':
        case 'next-bas-agent-bacnet-broker-handler-uat':
        case 'next-bas-agent-bacnet-broker-handler-prod':
            return {
                name:        'BACnet Broker',
                description: 'BACnet communications between the BAS Agent and the Building Optimization Broker.'
            };
        case 'next-bas-agent-bacnet-driver-handler-dev':
        case 'next-bas-agent-bacnet-driver-handler-uat':
        case 'next-bas-agent-bacnet-driver-handler-prod':
            return {
                name:        'BACnet Driver',
                description: 'Diagnostic information for the BACnet driver on the BAS Agent.'
            };
        case 'next-bas-agent-cloud-storage-success-handler-dev':
        case 'next-bas-agent-cloud-storage-success-handler-uat':
        case 'next-bas-agent-cloud-storage-success-handler-prod':
            return {
                name:        'Agent Actions',
                description: 'Communication between the BAS Agent and the Building Optimization Broker cloud infrastructure.'
            };
        case 'next-bas-agent-heartbeat-handler-dev':
        case 'next-bas-agent-heartbeat-handler-uat':
        case 'next-bas-agent-heartbeat-handler-prod':
            return {
                name:        'Heartbeat',
                description: 'Communication between the BAS Agent and the Building Optimization Broker client.'
            };
        case 'next-bas-agent-metrics-logging-handler-dev':
        case 'next-bas-agent-metrics-logging-handler-uat':
        case 'next-bas-agent-metrics-logging-handler-prod':
            return {
                name:        'Agent Metrics',
                description: 'The on-board metrics for the BAS Agent.'
            };
        case 'next-bas-agent-poll-handler-dev':
        case 'next-bas-agent-poll-handler-uat':
        case 'next-bas-agent-poll-handler-prod':
            return {
                name:        'Niagara Polling',
                description: 'Communication between the BAS Agent and the BAS for Niagara systems.'
            };
        case 'next-bas-agent-shadow-handler-dev':
        case 'next-bas-agent-shadow-handler-uat':
        case 'next-bas-agent-shadow-handler-prod':
            return {
                name:        'Shadow',
                description: 'BAS Agent shadow interactions.'
            };
        case 'syslog':
            return {
                name:        'System',
                description: 'System level diagnostics on the BAS Agent.'
            };
        default:
            return {
                name:        log,
                description: ''
            };
    }
};

export default logDescriptionTable;
